export default __webpack_public_path__ + "static/media/guide15.9585d6f6.png";